/* ----------- BURGER / NAV ---------- */
const burger  = document.getElementById('menu-toggle');
const nav     = document.querySelector('header nav');
const links   = [...document.querySelectorAll('#menu-list a')];

function toggleMenu(){
  // 1) on active la transition
  nav.classList.add('anim');

  // 2) on (dé)plie le menu
  burger.classList.toggle('open');
  nav.classList.toggle('open');

  // 3) on retire .anim après la durée CSS (300 ms ici)
  setTimeout(()=> nav.classList.remove('anim'), 300);
}

burger.addEventListener('click', toggleMenu);

links.forEach(l => l.addEventListener('click', () => {
  links.forEach(a => a.classList.remove('active'));
  l.classList.add('active');
  if(nav.classList.contains('open')) toggleMenu();
}));


// helper pour ID unique
const uid = () => 'yt-'+Math.random().toString(36).substr(2,9);

document.addEventListener('click', e=>{
  const cover = e.target.closest('.video-cover');
  if(!cover) return;

  // conteneur parent (div.video-box) gardera la taille
  const box = cover.parentElement;
  const id  = uid();

  // iframe sans autoplay
  const iframe = document.createElement('iframe');
  iframe.id  = id;
  iframe.src = 'https://www.youtube.com/embed/vQZdDkxHp3g?playsinline=1&enablejsapi=1&rel=0';
  iframe.allow = 'autoplay; encrypted-media';
  iframe.setAttribute('playsinline','');
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.border = 0;

  cover.replaceWith(iframe);

  // quand l'API est prête, on crée le player puis ON LANCE
  function apiReady(){
    const player = new YT.Player(id, {
      events:{
        onReady: e=>{
          e.target.mute();      // muet obligatoire
          e.target.playVideo(); // compte comme geste utilisateur
        }
      }
    });
  }

  if (window.YT && YT.Player) apiReady();
  else window.onYouTubeIframeAPIReady = apiReady;
});

document.querySelectorAll('.p-carousel').forEach(car => {
  const track = car.querySelector('.slides');
  const cards = [...car.querySelectorAll('.card')];
  const stepButtons = [...car.querySelectorAll('[data-carousel-step]')];

  if (!track || !cards.length || !stepButtons.length) return;

  const prevButtons = [
    car.querySelector('.carousel-wrapper > .nav.prev'),
    ...car.querySelectorAll('.carousel-controls__nav.prev'),
  ].filter(Boolean);

  const nextButtons = [
    car.querySelector('.carousel-wrapper > .nav.next'),
    ...car.querySelectorAll('.carousel-controls__nav.next'),
  ].filter(Boolean);

  const lastIndex = Math.max(0, cards.length - 1);

  const getSlideWidth = () => cards[0].offsetWidth || track.clientWidth || 1;

  const getIndex = () => {
    const index = Math.round(track.scrollLeft / getSlideWidth());
    return Math.max(0, Math.min(lastIndex, index));
  };

  const setDisabledState = (buttons, disabled) => {
    buttons.forEach(button => {
      button.classList.toggle('is-off', disabled);
      button.disabled = disabled;
    });
  };

  const updateNav = () => {
    const index = getIndex();
    setDisabledState(prevButtons, index <= 0);
    setDisabledState(nextButtons, index >= lastIndex);
  };

  const scrollToIndex = index => {
    const safeIndex = Math.max(0, Math.min(lastIndex, index));
    const target = cards[safeIndex];
    if (!target) return;

    track.scrollTo({
      left: target.offsetLeft,
      behavior: 'smooth',
    });
  };

  stepButtons.forEach(button => {
    button.addEventListener('click', () => {
      const step = Number(button.dataset.carouselStep || 0);
      scrollToIndex(getIndex() + step);
      setTimeout(updateNav, 220);
    });
  });

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateNav, 120);
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const target = cards[getIndex()];
      if (target) {
        track.scrollLeft = target.offsetLeft;
      }
      updateNav();
    }, 80);
  });

  updateNav();
});

document.querySelectorAll('[data-explore-carousel]').forEach(carousel => {
  const track = carousel.querySelector('.slides');
  const cards = [...carousel.querySelectorAll('.explore-card')];
  const stepButtons = [...carousel.querySelectorAll('[data-carousel-step]')];
  const desktopIndicators = [...carousel.querySelectorAll('.explore-carousel__indicators [data-explore-indicator]')];

  if (!track || !cards.length || !stepButtons.length) return;

  const prevButtons = stepButtons.filter(button => Number(button.dataset.carouselStep) < 0);
  const nextButtons = stepButtons.filter(button => Number(button.dataset.carouselStep) > 0);
  const lastIndex = Math.max(0, cards.length - 1);

  const getSlideWidth = () => cards[0].offsetWidth || track.clientWidth || 1;

  const getIndex = () => {
    const index = Math.round(track.scrollLeft / getSlideWidth());
    return Math.max(0, Math.min(lastIndex, index));
  };

  const setDisabledState = (buttons, disabled) => {
    buttons.forEach(button => {
      button.classList.toggle('is-off', disabled);
      button.disabled = disabled;
    });
  };

  const updateIndicators = index => {
    desktopIndicators.forEach(button => {
      const target = Number(button.dataset.carouselTarget || 0);
      const isActive = target === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const updateUI = () => {
    const index = getIndex();
    setDisabledState(prevButtons, index <= 0);
    setDisabledState(nextButtons, index >= lastIndex);
    updateIndicators(index);
  };

  const scrollToIndex = index => {
    const safeIndex = Math.max(0, Math.min(lastIndex, index));
    const target = cards[safeIndex];
    if (!target) return;

    track.scrollTo({
      left: target.offsetLeft,
      behavior: 'smooth',
    });
  };

  stepButtons.forEach(button => {
    button.addEventListener('click', () => {
      const step = Number(button.dataset.carouselStep || 0);
      scrollToIndex(getIndex() + step);
      setTimeout(updateUI, 220);
    });
  });

  desktopIndicators.forEach(button => {
    button.addEventListener('click', () => {
      scrollToIndex(Number(button.dataset.carouselTarget || 0));
      setTimeout(updateUI, 220);
    });
  });

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateUI, 120);
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const target = cards[getIndex()];
      if (target) {
        track.scrollLeft = target.offsetLeft;
      }
      updateUI();
    }, 80);
  });

  updateUI();
});
